export default ({ colors, spacings, fontWeights }) => ({
  result: {
    textAlign: 'center',
    marginTop: spacings.x2,
    marginBottom: spacings.x2,
    padding: `${spacings.default} ${spacings.x2}`
  },

  'result--error': {
    borderLeft: `.25rem solid ${colors.common.utility.error.default}`,
    backgroundColor: colors.common.utility.error.lightest
  },

  'result--success': {
    borderLeft: `.25rem solid ${colors.common.utility.success.default}`,
    backgroundColor: colors.common.utility.success.lightest
  },

  'result--info': {
    borderLeft: `.25rem solid ${colors.common.utility.info.default}`,
    backgroundColor: colors.common.utility.info.lightest
  },

  'result--warning': {
    borderLeft: `.25rem solid ${colors.common.utility.warning.default}`,
    backgroundColor: colors.common.utility.warning.lightest
  },

  title: {
    fontWeight: fontWeights.result.title,

    display: 'block'
  },

  message: {
    margin: '0'
  }
})



// WEBPACK FOOTER //
// ./components/result/styles.js